import { Component } from '@angular/core';

@Component({
  selector: 'payarc-filter-bar',
  template: `
    <div class="pa-filter">
      <div class="pa-filter__main"><ng-content></ng-content></div>
      <div class="pa-filter__actions"><ng-content select="[actions]"></ng-content></div>
    </div>
    <div class="pa-filter__chips"><ng-content select="[chips]"></ng-content></div>`,
  styleUrls: ['./payarc-filter-bar.component.css'],
  standalone: false
})
export class PayarcFilterBarComponent {}
